import { render, staticRenderFns } from "./SimpleHScroll.vue?vue&type=template&id=30556286&scoped=true"
import script from "./SimpleHScroll.vue?vue&type=script&lang=js"
export * from "./SimpleHScroll.vue?vue&type=script&lang=js"
import style0 from "./SimpleHScroll.vue?vue&type=style&index=0&id=30556286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30556286",
  null
  
)

export default component.exports